<template>
  <div class="layout">
    <Header :current-page="currentPage" />
    <main class="layout__main">
      <slot></slot>
    </main>
    <Footer v-if="currentPage !== 'home'" />
  </div>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'

export default {
  name: 'Layout',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      currentPage: 'home'
    }
  },
  mounted() {
    // 从 sessionStorage 恢复页面状态
    const savedPage = sessionStorage.getItem('currentPage')
    if (savedPage) {
      this.currentPage = savedPage
    }
    // 监听页面切换事件
    window.addEventListener('switchPage', this.handleSwitchPage)
  },
  beforeDestroy() {
    window.removeEventListener('switchPage', this.handleSwitchPage)
  },
  methods: {
    handleSwitchPage(event) {
      this.currentPage = event.detail.page
    }
  }
}
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.layout__main {
  flex: 1;
}
</style>
